// Indian currency + number formatting helpers.
const inr = new Intl.NumberFormat("en-IN", {
  style: "currency", currency: "INR", minimumFractionDigits: 2, maximumFractionDigits: 2,
});
const intFmt = new Intl.NumberFormat("en-IN");

export const formatINR = (v) => (v == null || Number.isNaN(Number(v)) ? "—" : inr.format(Number(v)));
export const formatInt = (v) => (v == null ? "0" : intFmt.format(Number(v)));
